function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0d0e0e;}.a,.b{stroke:#707070;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-36.53 -74.15)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M52.306,76.666l13.548,9.075v17.73H38.623V85.746l13.683-9.08m0-2.516L36.53,84.621v20.944H67.947V84.621L52.311,74.15Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.82 88.85)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M232.032,181.09H219.008v2.093h10.933V192.6h-11.6v2.111h12.727v-.023h.966V181.636h0Z",
  transform: "translate(-218.34 -177.973)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 13.027,
  height: 2.093,
  transform: "translate(0.668 0)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 3.255,
  height: 1.135,
  transform: "translate(4.735 12.455)"
}))));

function SvgIconEinfamilienhausGarage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.985,
    height: 32.438,
    viewBox: "0 0 44.985 32.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEinfamilienhausGarage);
export default __webpack_public_path__ + "static/media/IconEinfamilienhausGarage.d71c04a9f2fbc5c3955963d39a697fcc.svg";
export { ForwardRef as ReactComponent };